import React from 'react';
import './pricing-premium.css';

const TONES = {
  emerald: 'linear-gradient(135deg, #34d399, #059669)',
  amber: 'linear-gradient(135deg, #fbbf24, #d97706)',
  sky: 'linear-gradient(135deg, #38bdf8, #0284c7)',
  violet: 'linear-gradient(135deg, #818cf8, #4f46e5)',
};

/** Shared page header for the Pricing & Costs area. `info` renders a small hover tooltip instead of a banner. */
export const PricingHeader = ({ icon: Icon, tone = 'violet', title, subtitle, info, actions, testId }) => (
  <div className="pc-header" data-testid={testId}>
    <div className="pc-header-icon" style={{ background: TONES[tone] }}>{Icon && <Icon className="w-6 h-6" />}</div>
    <div className="min-w-0 flex-1">
      <h1>{title}{info && <span className="pc-info" data-tip={info} aria-label={info} tabIndex={0} data-testid={`${testId}-info`}>i</span>}</h1>
      {subtitle && <p>{subtitle}</p>}
    </div>
    {actions && <div className="pc-header-actions">{actions}</div>}
  </div>
);
